import React from 'react'
import Pagination from 'common/components/core/PaginationNew'
import { SearchResultsCard } from './search-results-card'
import {
  SearchResultsCardsWrapperUi,
  SearchResultsTotalTitleUi,
  SearchResultsWrapperUi,
} from './ui'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { SearchResultInterface } from 'common/types/search-interfaces'
import { CommonSearchResultsProps } from 'common/types/entities/search-results-interface'
import { useTranslation } from 'react-i18next'

interface SearchResultsProps extends CommonSearchResultsProps {
  paginationCurrent: number
  paginationTotal: number
  resultsTotal: number
  locale: PageLocaleEnum
  htmlAttrId: string
  data: SearchResultInterface[]
}

export const SearchResults = (props: SearchResultsProps) => {
  const { t } = useTranslation()
  return (
    <SearchResultsWrapperUi
      padding={props.padding}
      mobilePadding={props.mobilePadding}
    >
      <SearchResultsTotalTitleUi {...props.total}>
        {t('components.search.results_icu', {
          count: props.resultsTotal,
        })}
      </SearchResultsTotalTitleUi>
      <SearchResultsCardsWrapperUi>
        {props.data.map(el => (
          <SearchResultsCard
            key={el.id}
            locale={props.locale}
            content={el.content ? el.content : el.description}
            date={el.publication_date}
            title={el.name}
            image={el.image}
            path={el.path}
            card={props.card}
            cardTitle={props.title}
            cardText={props.text}
            cardDate={props.date}
          />
        ))}
      </SearchResultsCardsWrapperUi>
      <Pagination
        current={props.paginationCurrent}
        total={props.paginationTotal}
        paginationActiveColor={props.pagination?.activeColor}
        mobilePaginationActiveColor={props.pagination?.mobileActiveColor}
        paginationActiveBackgroundColor={
          props.pagination?.activeBackgroundColor
        }
        mobilePaginationActiveBackgroundColor={
          props.pagination?.mobileActiveBackgroundColor
        }
        paginationInactiveColor={props.pagination?.inactiveColor}
        mobilePaginationInactiveColor={props.pagination?.mobileInactiveColor}
        paginationInactiveBackgroundColor={
          props.pagination?.inactiveBackgroundColor
        }
        mobilePaginationInactiveBackgroundColor={
          props.pagination?.mobileInactiveBackgroundColor
        }
      />
    </SearchResultsWrapperUi>
  )
}
